import HandleResponses from '@common/utils/handleApiResponsesV2';
import bdrAxios from '../../../axios-bdr';
import tmsMdmAxiosInstance from '../../../tms-mdm-axios';

import { create, remove, search, update } from '@/api-factory/mdm';
import { createMieone, searchMieone, updateMieone } from '@/api-factory/mdmMieone';

function getAxiosBySection(section) {
  return section === 'bfr' ? bdrAxios : tmsMdmAxiosInstance;
}

const actions = {
  async search({ commit }, { section, params, isMieone }) {
    if (params.page === 1) {
      commit('SET_LOADING', true);
    } else {
      commit('paginationCheck', true);
    }
    try {
      let result = [];
      if (isMieone) {
        result = await searchMieone({ section, params });
      } else {
        result = await search({ section, params });
      }
      if (result) {
        commit('SET_LIST', result);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('SET_LOADING', false);
    }
  },
  async excludeList({ commit }, params) {
    try {
      const result = await tmsMdmAxiosInstance('/vehicle_type', { params });
      commit('setExcludeVehicles', result.data);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async list(_, { section }) {
    try {
      const axiosInstance = getAxiosBySection(section);
      const result = await axiosInstance(`/${section}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async create({ commit }, { section, data, isMieone }) {
    try {
      let result = {};
      if (isMieone) {
        result = await createMieone({ section, data });
      } else {
        result = await create({ section, data });
      }
      if (result) {
        commit('appendNew', { data: result });
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async update({ commit }, { section, Id, data, isMieone, packingKeyToCompare = 'code' }) {
    try {
      let result = {};
      if (isMieone) {
        if (section === 'shipmethod') {
          result = await createMieone({ section, data });
        } else {
          result = await updateMieone({ section, Id, data });
        }
        if (result) {
          commit('updateExisting', { Id, data: result, keyToCompare: packingKeyToCompare });
        }
      } else {
        result = await update({ section, Id, data });
        if (result) {
          commit('updateExisting', { Id, data: result });
        }
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async remove({ commit }, { section, data }) {
    try {
      let result = {};
      result = await remove({ section, data });
      if (result && result.id) {
        commit('removeExisting', { data: result });
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async bulkUpload({ commit }, { section, formData, subPath = '' }) {
    commit('setuploadStatus', true);
    try {
      const axiosInstance = getAxiosBySection(section);
      const result = await axiosInstance.post(`/${section}/bulk_upload/${subPath}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('setuploadStatus', false);
      return HandleResponses.Status(error);
    }
  },
  async gateBulkUpload({ commit }, { formData }) {
    try {
      commit('setuploadStatus', true);
      const result = await tmsMdmAxiosInstance.post('/depot/gate_bulk_upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('setuploadStatus', false);
      return HandleResponses.Status(error);
    }
  },

  async uploadStatus({ commit }, { section, uploadType }) {
    try {
      let url = `/${section}/upload_status`;
      if (uploadType) {
        url = `${url}?type=${uploadType}`;
      }
      if (section === 'consignee' && uploadType === null) {
        url = `${url}?type=1`;
      }
      if (section === 'depot' && uploadType === null) {
        url = `${url}?type=depots`;
      }
      const axiosInstance = getAxiosBySection(section);
      const result = await axiosInstance(url);
      if (result.data && result.data.code === 'COMPLETED') {
        commit('setuploadStatus', false);
      }
      return result.data;
    } catch (error) {
      commit('setuploadStatus', false);
      return HandleResponses.Status(error);
    }
  },

  async containerVehiclesList() {
    try {
      const result = await tmsMdmAxiosInstance('container/vehicle/search?list=all');
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async freightForwardersList({ commit }, params) {
    try {
      const result = await tmsMdmAxiosInstance('freightforwarder', { params });
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async portList({ commit }, params) {
    try {
      commit('SET_LOADING', true);
      const result = await tmsMdmAxiosInstance('port', { params });
      if (result && result.data) {
        commit('SET_ALL_ACTIVE_PORT', result.data);
      }
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('SET_LOADING', false);
    }
  },

  async portSearch({ commit }, params) {
    try {
      const result = await tmsMdmAxiosInstance('port/search', { params });
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async activeFreightForwaders({ commit }, params) {
    try {
      const result = await tmsMdmAxiosInstance('/freightforwarder', { params });
      if (result && result.data) {
        commit('SET_ALL_ACTIVE_FF', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },
  async activeConatiners({ commit }, params) {
    try {
      const result = await tmsMdmAxiosInstance('/container/search', { params });
      if (result && result.data) {
        commit('SET_ALL_ACTIVE_CONTAINER', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },

  async paginate({ commit }, { section, params }) {
    try {
      if (params.page === 1) {
        commit('setLoadingStatus', true);
      } else {
        commit('paginationCheck', true);
      }
      const axiosInstance = getAxiosBySection(section);
      const result = await axiosInstance(`/${section}`, { params });
      commit('setAll', result.data);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('paginationCheck', false);
      commit('setLoadingStatus', false);
    }
  },
  async activeCHA({ commit }, params) {
    try {
      const result = await tmsMdmAxiosInstance('/cha', { params });
      if (result && result.data) {
        commit('SET_ALL_ACTIVE_CHA', result.data);
      }
      return result.data;
    } catch (error) {
      return error;
    }
  },
  async getExcelHeader(_, { section }) {
    try {
      const axiosInstance = getAxiosBySection(section);
      const result = await axiosInstance({
        url: `${section}/excel_header`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        if (section === 'contract') {
          section = 'Rate_Matrix';
        }
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${section}_bulk_upload.xlsx`);
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getadditionalExcelHeader(_, { section }) {
    try {
      const result = await tmsMdmAxiosInstance({ url: `${section}/additional_excel_header`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${section}_additional_bulk_upload.xlsx`);
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async export({ commit }, { section, params }) {
    commit('setDownloadStatus', true);
    if (section === 'vehicledetail' && params.vehicle_number) {
      params.vehicle_number = params.vehicle_number.toUpperCase().replace(/ /g, '');
    }
    try {
      const result = await tmsMdmAxiosInstance({
        url: '/export',
        method: 'GET',
        params,
        responseType: 'blob',
      });
      if (result.size) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        const fileName = params.entity_type ? params.entity_type : section;
        link.setAttribute('download', `${fileName}-export-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
      }
      return (result.size === 0) ? 'EXPORT_VIA_EMAIL' : false;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setDownloadStatus', false);
    }
  },
  async rejectDownload({ commit }, { section, transactionIds }) {
    commit('setDownloadStatus', true);
    try {
      const result = await tmsMdmAxiosInstance({
        url: `/${section}/rejected/download?transaction_ids=${transactionIds.join(',')}`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `${section}-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('setDownloadStatus', false);
    }
  },
  async show({ commit }, { section, id }) {
    try {
      const result = await tmsMdmAxiosInstance(`/${section}/${id}/show`);
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async associatedMaterialRejectDownload({ commit }, { section, transactionIds }) {
    commit('setDownloadStatus', true);
    try {
      const result = await tmsMdmAxiosInstance({ url: `/${section}/rejected/download/associated_material?transaction_ids=${transactionIds.join(',')}`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `${section}-associated-material-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('setDownloadStatus', false);
    }
  },

  async userMaterialRejectionDownload({ commit }, { section, transactionIds }) {
    commit('setDownloadStatus', true);
    try {
      const result = await tmsMdmAxiosInstance({ url: `/${section}/rejected/download/user_associated_material?transaction_ids=${transactionIds.join(',')}`,
        method: 'GET',
        responseType: 'blob' });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        const now = new Date().toISOString();
        link.setAttribute('download', `${section}-user-associate-rejectedList-${now}.xlsx`); // or any other extension
        document.body.appendChild(link);

        link.click();
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('setDownloadStatus', false);
    }
  },

  // rate-matrix
  async getSkuCategory({ commit }, { id, params }) {
    commit('setShowLoading', true);
    try {
      const result = await tmsMdmAxiosInstance(`/contrat/${id}/sku_category`, { params });
      if (result) {
        commit('setAll', result.data);
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },

  async getContractDetails(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance(`/contrat/${id}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getDestinationChargeDetails(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance(`/destination_charge/${id}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getSourceChargeDetails(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance(`/source_charge/${id}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async getConsigneeDetails(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance(`/consignee/${id}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async getConsigneeUserDetails(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance(`/consignee/user/${id}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async deleteConsigneeUser(_, { payload }) {
    try {
      const result = await tmsMdmAxiosInstance.delete(`/consignee/user/${payload.consigneeId}/${payload.id}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getMaterialDetails(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance(`/material/${id}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async getAssociateUsersDetails(_, { id, materialType }) {
    try {
      const result = await tmsMdmAxiosInstance(`/material/${id}/get_associate/${materialType}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async getDepotDetails(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance(`/depot/${id}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async getDockDetails(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance(`/depot/${id}/dock`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  async getGateDetails(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance(`/depot/${id}/gate`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  /**
     * @method createBucc
     * @body payload for creating Bucc Data
     * Create a new entry in Cost-Center Collection
     */
  async createBucc(_, { payload }) {
    try {
      const result = await tmsMdmAxiosInstance.post('/bucc', payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  /**
     * @method editBucc
     * @body payload for editing Bucc Data. Id as query-params
     * Update an existing entry in Cost-Center Collection
     */
  async editBucc(_, { payload, buccId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`bucc/${buccId}`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getRouteDetails(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance.get(`/route_master/${id}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  /**
     * @method getContractHistory
     * @param id of the contract
     * Get expired contracts for a contract
     */
  async getContractHistory({ commit, state }, { id, params }) {
    commit('setShowLoading', true);
    try {
      const result = await tmsMdmAxiosInstance(`/expired_contract/${id}`, { params });
      // This is done since we will be showing only 5 expired contracts in Timeline
      result.data = result.data.slice(0, 5);
      if (result) {
        commit('setAll', { ...state.all, Expired: result.data });
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },

  /**
       * @method getContractFuture
       * @param id of the contract
       * Get Future contracts for a contract
       */
  async getContractFuture({ commit, state }, { id, params }) {
    commit('setShowLoading', true);
    try {
      const result = await tmsMdmAxiosInstance(`/future_contract/${id}`, { params });
      if (result) {
        commit('setAll', { ...state.all, Future: result.data });
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },
  async editVehicleDetails(_, { payload, number, transporterId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`/vehicledetail/${number}/${transporterId}`, { data: payload });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async editVehicleType(_, { payload }) {
    try {
      const result = await tmsMdmAxiosInstance.put('/vehicledetail/update_vehicle_type', { data: payload });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async editRateMatrix(_, { payload, contractId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`contract/${contractId}`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async editConsignee(_, { payload, consigneeId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`consignee/${consigneeId}`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async updateConsigneeCoordinates(_, { payload, consigneeId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`consignee/${consigneeId}/update_coordinates/`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async editMaterial(_, { payload, materialId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`material/${materialId}`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async editDepot(_, { payload, depotId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`depot/${depotId}`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async editGate(_, { payload, depotId, gateId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`depot/${depotId}/gate/${gateId}`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async createConsignee(_, { payload }) {
    try {
      const result = await tmsMdmAxiosInstance.post('/consignee', payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async createConsigneeUser(_, { consigneeId, payload }) {
    try {
      const data = payload;
      const result = await tmsMdmAxiosInstance.post(`/consignee/user/${consigneeId}`, data);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async createMaterial(_, { payload }) {
    try {
      const result = await tmsMdmAxiosInstance.post('/material', payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async createDepot(_, { payload }) {
    try {
      const result = await tmsMdmAxiosInstance.post('/depot', payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async editRoute(_, { payload, routeId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`route_master/${routeId}`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async createGate(_, { payload, depotId }) {
    try {
      const result = await tmsMdmAxiosInstance.post(`/depot/${depotId}/gate`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async createRoute(_, { payload }) {
    try {
      const result = await tmsMdmAxiosInstance.post('/route_master', payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async createDock(_, { payload, depotId }) {
    try {
      const result = await tmsMdmAxiosInstance.post(`/depot/${depotId}/dock`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async updateDock(_, { payload, depotId, dockId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`/depot/${depotId}/dock/${dockId}`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async deleteSlab(_, payload) {
    try {
      const result = await tmsMdmAxiosInstance.delete(`/contract/${payload.contractId}/slab_rates/${payload.slabId}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async deleteSkuCategory(_, payload) {
    try {
      const result = await tmsMdmAxiosInstance.delete(`/contract/${payload.contractId}/sku_category/${payload.categoryId}`);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getKmSlabRates({ commit }, { id, params }) {
    commit('setShowLoading', true);
    try {
      const result = await tmsMdmAxiosInstance(`/contract/${id}/km_slab_rates`, { params });
      if (result) {
        commit('setAll', result.data);
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },
  async getHeadersFromConfig({ commit }, { section }) {
    try {
      commit('SET_LOADING', true);
      const result = await tmsMdmAxiosInstance.get(`/${section}/config_fields`);
      if (result && result.data) {
        commit('setHeader', result.data);
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async driverBlacklistHistory({ commit }, data) {
    commit('SET_LOADING', true);
    try {
      if (data.id) {
        const result = await tmsMdmAxiosInstance(`/driver/${data.id}/blacklist_history`);
        return result && result.data;
      }
      return {};
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('SET_LOADING', false);
    }
  },
  async materialMapList(_, params) {
    try {
      const result = await tmsMdmAxiosInstance(`/material_package_map/search/${params.id}`);
      return result && result.data;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },

  async downloadUploadedExcel(_, { section, id }) {
    try {
      const result = await tmsMdmAxiosInstance({
        url: `${section}/${id}/download`,
        method: 'GET',
        responseType: 'blob',
      });
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${section}_uploaded_excel.xlsx`);
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async approveRequest({ commit }, { id }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`approval/${id}/approve`);
      if (result && result.data) {
        commit('updateExisting', { id, data: result.data });
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async rejectRequest({ commit }, { id, payload }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`approval/${id}/reject`, payload);
      if (result && result.data) {
        commit('updateExisting', { id, data: result.data });
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async bulkUploadMdm(_, { formData }) {
    try {
      const result = await tmsMdmAxiosInstance.post(`bulk_upload/?type=${formData.get('id')}&uploadType=${formData.get('subId')}`, formData, { headers: {
        'Content-Type': 'multipart/form-data',
      } });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async bulkUploadApproveMdm(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance.post(`/bulk_upload/approve/${id}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async bulkUploadConfirmMdm(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance.post(`/bulk_upload/confirm/${id}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async bulkUploadDiscardMdm(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance.post(`/bulk_upload/discard/${id}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async bulkUploadRejectMdm(_, { id, params }) {
    try {
      const result = await tmsMdmAxiosInstance.post(`/bulk_upload/reject/${id}`, params);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getBulkUploadListData(_, params) {
    try {
      const result = await tmsMdmAxiosInstance.get('/bulk_upload', { params });
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getNoOfApprovalsPending() {
    try {
      const result = await tmsMdmAxiosInstance.get('/bulk_upload/approvals_pending_count');
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getBulkUploadItem(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance.get(`/bulk_upload/${id}`);
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getStatusChange(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance.get(`/bulk_upload/${id}/upload_status`);
      if (result && result.data) {
        return result.data;
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async downloadExcelFileMdm(_, { data, fileName, selectedMaster }) {
    try {
      const result = await tmsMdmAxiosInstance({
        url: '/bulk_upload/file',
        method: 'POST',
        responseType: 'blob',
        data,
      }, data);
      if (result) {
        const url = window.URL.createObjectURL(new Blob([result]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${selectedMaster}_${fileName}.xlsx`);
        document.body.appendChild(link);
        link.click();
      }
      return true;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async userMaterialBulkUpload({ commit }, { section, formData }) {
    commit('setuploadStatus', true);
    try {
      const result = await tmsMdmAxiosInstance.post(`/${section}/import_material_user_association/bulkupload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return HandleResponses.Status(result);
    } catch (error) {
      commit('setuploadStatus', false);
      return HandleResponses.Status(error);
    }
  },

  async getSourceDestinationList(_, { query }) {
    try {
      const result = await tmsMdmAxiosInstance.get(`user/all_depot?name=${query}`);
      if (result && result.data) {
        return result.data;
      } return [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getMaterialBrandList(_, { query }) {
    try {
      const result = await tmsMdmAxiosInstance.get(`material/brand/search?query=${query}`);
      if (result && result.data) {
        return result.data;
      } return [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getMaterialSubBrandList(_, { query }) {
    try {
      const result = await tmsMdmAxiosInstance.get(`material/sub_brand/search?query=${query}`);
      if (result && result.data) {
        return result.data;
      } return [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getMaterialCodeList(_, { query }) {
    try {
      const result = await tmsMdmAxiosInstance.get(`material/code/search?query=${query}`);
      if (result && result.data) {
        return result.data;
      } return [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getMaterialCategoryList(_, { query }) {
    try {
      const result = await tmsMdmAxiosInstance.get(`material/category/search?query=${query}`);
      if (result && result.data) {
        return result.data;
      } return [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getMaterialCategory(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance.get(`/materialcategory/${id}`);
      if (result && result.data) {
        return result.data;
      } return [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getAllMaterialCategoryList(_) {
    try {
      const result = await tmsMdmAxiosInstance.get('/materialcategory?list=all');
      if (result && result.data) {
        return result.data;
      } return [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async fetchMaterialCategories(_, params) {
    try {
      const result = await tmsMdmAxiosInstance.get('/materialcategory', { params });
      if (result && result.data) {
        return result.data;
      } return [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async createMaterialCategory(_, { payload }) {
    try {
      const result = await tmsMdmAxiosInstance.post('/materialcategory', payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async editMaterialCategory(_, { payload, categoryId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`/materialcategory/${categoryId}`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async addRedirectionEntry(_, { payload }) {
    try {
      const result = await tmsMdmAxiosInstance.post('/redirection', payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async editRedirectionEntry(_, { payload, redirectionId }) {
    try {
      const result = await tmsMdmAxiosInstance.put(`/redirection/${redirectionId}`, payload);
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async getConsigneeLocations(_) {
    try {
      const result = await tmsMdmAxiosInstance.get('/consignee/locations');
      if (result && result.data) {
        return result.data;
      } return [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },


  async getRedirectionEntry(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance.get(`/redirection/${id}`);
      if (result && result.data) {
        return result.data;
      } return [];
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  /**
   * BFR related actions
   */
  async stopBdr({ commit }, { params }) {
    try {
      const result = await bdrAxios.put(`/bfr/${params.id}`, { data: { stop_update: true } });
      if (result && result.data) {
        commit('updateExisting', { data: result.data });
      }
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async stopAllBdr(_, { bdrIds }) {
    try {
      const result = await bdrAxios.post('/bfr/stop_all', { data: { bdr_ids: bdrIds } });
      return result && result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },
  async getBdrHistory({ commit }, { bdrId }) {
    commit('setDownloadStatus', true);
    try {
      const result = await bdrAxios({ url: `/bfr/bdr_history/${bdrId}` });
      if (result) {
        commit('setCurrentBdr', result.data);
        return result.data;
      }
      return true;
    } catch (err) {
      return err;
    } finally {
      commit('setDownloadStatus', false);
    }
  },
  async getHeaders({ commit }, { section }) {
    try {
      commit('setLoadingStatus', true);
      const result = await tmsMdmAxiosInstance.get(`/${section}/config_fields`);
      if (result && result.data) {
        commit('setHeader', result.data);
      }
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    } finally {
      commit('setShowLoading', false);
    }
  },
  async getBdrSlabRates({ commit }, { bdrCategory }) {
    try {
      const result = await bdrAxios({ url: `/bfr/bdr_slab/${bdrCategory}` });
      if (result) {
        commit('setBdrSlabs', result.data);
        return result.data;
      }
      return [];
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
  // Delete Future contract from  future contract and contract collection with the given id
  async deleteContract(_, { id }) {
    try {
      const result = await tmsMdmAxiosInstance.delete(`/contract/${id}`);
      return result;
    } catch (err) {
      return HandleResponses.Status(err);
    }
  },
};
export default actions;
